import styled from 'styled-components';

export const PreArrivalFormTabContainer = styled.div`
  position: relative;
`;

export const PreArrivalFormTabFooterStyled = styled.footer`
  height: 75px;
  position: sticky;
  background-color: #fff;
  bottom: 0;
  z-index: 1000;

  & > div {
    display: flex;
    justify-content: flex-end;
  }

  button {
    margin-bottom: 20px;
    float: right;
  }
`;
